import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqData = [
        { question: 'What is Yaniva?', answer: 'Yaniva is a premium corporate advisory and investment platform, offering structured solutions for SME IPOs, growth capital, and financial insights.' },
        { question: 'What services does Yaniva offer?', answer: 'Yaniva provides a comprehensive suite of financial advisory services including SME IPO consulting, IPO Management, Mergers & Acquisitions, and strategic investor PR.' },
        { question: 'What is an IPO?', answer: 'An IPO, or Initial Public Offering, is the process by which a private company first offers shares of its stock to the public on a stock exchange. This transition allows the business to raise public capital by selling shares to retail and institutional investors.' },
        { question: 'What is the Lock-in period in IPOs?', answer: 'A lock-in (or lock-up) period is a designated timeframe after an IPO during which promoters, early investors, and employees are legally restricted from selling their shares. This prevents market oversaturation and helps stabilize the initial trading price.' },
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div id="faq" className="bg-white py-12 md:py-16">
            <div className="container mx-auto px-6 max-w-4xl">
                
                {/* Header */}
                <div className="text-center mb-10" data-aos="fade-up">
                    <span className="text-sm font-semibold tracking-wider uppercase text-cyan-600 mb-2 block">
                        Got Questions?
                    </span>
                    <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4">
                        Frequently Asked Questions
                    </h2>
                    <div className="flex justify-center">
                        <div className="w-16 h-1 bg-cyan-500 rounded-full"></div>
                    </div>
                </div>

                {/* Accordion List */}
                <div className="space-y-4" data-aos="fade-up" data-aos-delay="200">
                    {faqData.map((item, index) => {
                        const isOpen = activeIndex === index;
                        return (
                            <div 
                                key={index} 
                                className={`border rounded-2xl transition-all duration-200 overflow-hidden ${
                                    isOpen 
                                        ? 'border-cyan-200 bg-cyan-50/20 shadow-sm shadow-cyan-100/50' 
                                        : 'border-slate-100 hover:border-slate-200 bg-slate-50/50'
                                }`}
                            >
                                <button
                                    onClick={() => toggleAccordion(index)}
                                    className="w-full flex justify-between items-center px-6 py-5 text-left font-semibold text-slate-800 focus:outline-none transition-colors duration-200"
                                >
                                    <span className="text-base md:text-lg pr-4">{item.question}</span>
                                    <span className={`text-slate-400 shrink-0 p-1 bg-white rounded-lg border border-slate-100 transition-transform duration-200 ${isOpen ? 'rotate-180 text-cyan-600 border-cyan-100' : ''}`}>
                                        <ChevronDown size={18} />
                                    </span>
                                </button>

                                <div 
                                    className={`transition-all duration-300 ease-in-out ${
                                        isOpen ? 'max-h-96 opacity-100 border-t border-cyan-100/50' : 'max-h-0 opacity-0 pointer-events-none'
                                    }`}
                                >
                                    <p className="px-6 py-5 text-slate-600 text-sm md:text-base leading-relaxed bg-white/50">
                                        {item.answer}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>

            </div>
        </div>
    );
};

export default FAQ;
